import React from 'react'
import SidebarItem from './SidebarItem'

const SidebarSection = ({
  section,
  expanded,
  openSubmenuKey,
  onSubmenuOpen,
  onSubmenuClose,
  onNavigate
}) => {
  if (!section.items || section.items.length === 0) return null

  return (
    <div className="app-sidebar__section">
      {section.label && <div className="app-sidebar__section-label">{section.label}</div>}
      <ul className="app-sidebar__list">
        {section.items.map((item) => (
          <SidebarItem
            key={item.key || item.name}
            item={item}
            expanded={expanded}
            isSubmenuOpen={openSubmenuKey === item.key}
            onSubmenuOpen={() => onSubmenuOpen(item.key)}
            onSubmenuClose={() => onSubmenuClose(item.key)}
            onNavigate={onNavigate}
          />
        ))}
      </ul>
    </div>
  )
}

export default SidebarSection
